import identifierMap from './identifiers.data.json';

const iqID = { ...identifierMap };

export default iqID;
